export default __webpack_public_path__ + "static/media/sellers-1.d29411de.png";